import { useMutation } from '@apollo/client';
import { graphql } from '@packages/charka-common-ui/graphql/types';

const MUTATION = graphql(`
  mutation CreatePageRule($input: CreatePageRuleInput!) {
    createPageRule(input: $input) {
      id
    }
  }
`);

export function useCreatePageRule() {
  return useMutation(MUTATION, {
    refetchQueries: ['PrintRule', 'PageRuleData'],
  });
}
